import { useQuery } from '@apollo/client';
import { GET_PUSH_NOTIFICATION_CAPABILITY_QUERY } from 'src/graphql/entities/push-notification/push-notification.operations';

export type PushNotificationSubscription = {
  id: string;
  endpoint: string;
  userAgent: string | null;
  isActive: boolean;
  lastFailedAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export type PushNotificationCapability = {
  vapidPublicKey: string;
  subscriptions: PushNotificationSubscription[];
};

type GetPushNotificationCapabilityQuery = {
  getPushNotificationCapability: PushNotificationCapability;
};

export const usePushNotificationCapability = (options: { skip?: boolean } = {}) => {
  const { data, loading, refetch } = useQuery<GetPushNotificationCapabilityQuery>(
    GET_PUSH_NOTIFICATION_CAPABILITY_QUERY,
    {
      skip: options.skip ?? false,
      fetchPolicy: 'no-cache',
      context: {
        ttl: 0,
      },
    },
  );

  return {
    capability: data?.getPushNotificationCapability,
    loading,
    refetch,
  };
};
